import { authService, authInterceptor } from "@rosgidromet/visary-identity-vue-rgm";
import log from "./log";

const fetchToken = async () => ({ Token: await authService.getAccessToken() });

const refreshToken = async () => {
  const authDelegate = authInterceptor.getFetchAndSaveTokensDelegate();

  if (authDelegate) {
    try {
      await authDelegate();
      return { Token: await authService.getAccessToken() };
    } catch (e) {
      log.error(e);
      throw e;
    }
  } else {
    throw new Error("Refresh token failed: authDelegate is null");
  }
};

export default {
  fetchToken,
  refreshToken
}
